import { makeAutoObservable, reaction, toJS } from 'mobx';
import { waitUntil } from '../../utils/WaitUntil';

class InteractiveStore {
	rootStore;

	isConnect = false;
	isStart = false;

	downloadProgress = 0;
	seekPercentage = null;

	currentNodeId = null;

	conditions = [];
	onConditionsUpdated = null;

	similarColors = {
		red: ['pink', 'orange'],
		pink: ['red', 'orange'],
		orange: ['red', 'pink'],
		blue: ['cyan', 'green'],
		cyan: ['blue', 'green'],
		green: ['blue', 'cyan'],
	};

	constructor(root) {
		makeAutoObservable(this);
		this.rootStore = root;

		this.clear();

		reaction(
			() => toJS(this.conditions),
			() => {
				console.log('[MobX] Conditions changed:', this.conditions);
				console.log('[MobX] onConditionsUpdated is', this.onConditionsUpdated);
				this.onConditionsUpdated?.(this.conditions);
			},
		);
	}

	setIsStart(value = !this.isStart) {
		this.isStart = value;
	}

	getIsReady() {
		return (
			this.isConnect && !this.isStart && this.rootStore.likuStore.thisLiku?.uuid
		);
	}

	setIsConnect(data) {
		this.isConnect = data;
	}

	setOnConditionsUpdated(handler) {
		console.log('[MobX] onConditionsUpdated 등록됨', handler);
		this.onConditionsUpdated = handler;

		if (this.conditions.length > 0) {
			handler(this.conditions);
		}
	}

	async checkLikuConnect() {
		const liku = this.rootStore.likuStore.thisLiku;

		if (!liku) return;
		await waitUntil(() => !!this.rootStore.likuStore.thisLiku?.language, 100);

		const language = this.rootStore.likuStore.thisLiku.language;

		if (language !== 'ko') {
			await new Promise((resolve) => {
				this.rootStore.mqttStore.likuMqtt.setLanguage('ko', resolve);
			});
		}

		this.rootStore.mqttStore.playerMqtt.setContentsConnect(() => {
			this.setIsConnect(true);
		});
	}

	getCurrentNode(flow) {
		return flow.nodes.find((node) => node.id === this.currentNodeId);
	}

	setCurrentNodeId(value) {
		this.currentNodeId = value;
	}

	setConditions(condition) {
		console.log('setConditions', condition);
		if (condition) {
			this.conditions.push(condition);
		} else {
			this.conditions = [];
		}
	}

	setDownloadProgress(value) {
		this.downloadProgress = value;
	}

	setSeekPercentage(percentage) {
		this.seekPercentage = percentage;
	}

	getSortedNodeIds(nodes, edges) {
		const nodeSet = new Set(nodes.map((n) => n.id));
		const incomingEdgeCount = {};
		const graph = {};

		nodeSet.forEach((id) => {
			incomingEdgeCount[id] = 0;
			graph[id] = [];
		});

		edges.forEach(({ source, target }) => {
			if (graph[source]) graph[source].push(target);
			incomingEdgeCount[target]++;
		});

		const queue = [];
		for (const id of nodeSet) {
			if (incomingEdgeCount[id] === 0) {
				queue.push(id);
			}
		}

		const sorted = [];
		const visited = new Set();

		while (queue.length > 0) {
			const current = queue.shift();
			sorted.push(current);
			visited.add(current);

			for (const next of graph[current]) {
				incomingEdgeCount[next]--;
				if (incomingEdgeCount[next] === 0) {
					queue.push(next);
				}
			}
		}

		for (const id of nodeSet) {
			if (!visited.has(id)) {
				sorted.push(id);
			}
		}

		return sorted;
	}

	resolveCondition(candidates) {
		console.log('candidates  ', candidates);
		for (const { target, condition } of candidates) {
			if (!condition) return target;

			if (
				this.conditions.some(
					(c) => c.type === condition?.type && c.value === condition?.value,
				)
			) {
				return target;
			}
		}
	}

	async handleConditionIfNeeded(condition) {
		if (!condition) return false;

		if (condition.type === 'Button') {
			return true;
		}

		return false;
	}

	clearHandler() {
		this.onConditionsUpdated = null;
	}

	clear(isAll = true) {
		if (isAll) {
			this.isConnect = false;
			// this.onConditionsUpdated = null;
		}
		this.isStart = false;

		this.downloadProgress = 0;
		this.seekPercentage = null;

		this.currentNodeId = null;

		this.conditions = [];
	}
}

export default InteractiveStore;
